import { forwardRef, TextareaHTMLAttributes } from 'react';
import { cn } from './cn';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid, className, ...rest },
  ref
) {
  return (
    <textarea
      ref={ref}
      data-tss-ui=""
      data-invalid={invalid || undefined}
      className={cn('tss-textarea', className)}
      aria-invalid={invalid || undefined}
      {...rest}
    />
  );
});
